import { render } from "./ReportPieChart.vue?vue&type=template&id=408b503a&scoped=true"
import script from "./ReportPieChart.vue?vue&type=script&lang=js"
export * from "./ReportPieChart.vue?vue&type=script&lang=js"

import "./ReportPieChart.vue?vue&type=style&index=0&id=408b503a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408b503a"]])

export default __exports__